/* eslint-disable strict */

'use strict';

/**
 * Update product variant pricing.
 * Can be triggered by multiple events:
 *   'cart:change' event triggered by AjaxCart
 *   'change' event triggered by product variant form <select>
 *   'change' event triggered by buy bar <select>
 */
(async function VariantSelect() {
  var manualPriceUpdateAndEmit = Simba.Functional.compose(emitVariantChange, productFormMDVupdate, eventData);
  var productFormMDV = Simba.ModelDrivenView.init($('[data-mdv-product-form]'));
  var productGalleryOverlayMDV = Simba.ModelDrivenView.init($('[data-mdv-product-gallery-overlay]'));
  var $variantSelect = $('[data-product-form] [data-variant-select]');

  document.addEventListener('cart:change', priceUpdateAndEmit, false);
  document.addEventListener('bed-configurator:change', priceUpdateAndEmit, false);
  document.addEventListener('bed-configurator:complete', priceUpdateAndEmit, false);

  document.addEventListener('simple-bed-variant:update', manualPriceUpdateAndEmit, false);

  $variantSelect.on('change', priceUpdateAndEmit);

  // PK I think this can be delteted
  // window.SimbaTiered = window.SimbaTiered || {};
  // window.SimbaTiered.priceUpdate = priceUpdateAndEmit;

  await priceUpdateAndEmit();

  async function priceUpdateAndEmit() {
    const variant = await collateData().variant;
    if (typeof variant !== 'undefined') {
      const updateObject = {
        variant: variant
      };
      const data = productFormMDVupdate(updateObject);
      emitVariantChange(data);
    }
  }

  function productFormMDVupdate(data) {
    var variant = data.variant;
    var financeInstalmentValue = 0;
    var variantEligibleForFinance = false;
    if (typeof variant !== 'object') return data;

    if (Simba.FinanceCalculator.length > 0) {
      if (variant.finance.price >= Simba.FinanceCalculator[0].instalment12Threshold) {
        financeInstalmentValue = variant.finance.lowestInstalmentPriceFormatted;
        variantEligibleForFinance = true;
      } else if (variant.finance.price >= Simba.FinanceCalculator[0].financeThreshold) {
        /**
         * instalmentPriceFormatted Array:
         *  3 Months
         *  6 Months
         *  12 Months
         */
        financeInstalmentValue = variant.finance.instalmentPriceFormatted[2];
        variantEligibleForFinance = true;
      }
    }

    // START: CRO SIM-3592 START
    const $variantTitles = document.querySelectorAll('[data-variant-title]');
    if ($variantTitles.length > 0) {
      $variantTitles.forEach((el) => {
        el.innerHTML = variant.variantTitle.split(':')[0].split(' / ')[0];
      });
    }

    const $variantPackSizes = document.querySelectorAll('[data-variant-pack-size]');
    if ($variantPackSizes.length > 0) {
      $variantPackSizes.forEach((el) => {
        el.innerHTML = variant.variantTitle.split(':')[0].split(' / ')[1] || '';
      });
    }
    // END: CRO SIM-3592 END

    // Update the view
    productFormMDV.setPrice = variant.priceFormattedWithoutTrailingZeros;
    productFormMDV.setOriginalPrice = variant.originalPriceFormattedWithoutTrailingZeros;
    productFormMDV.setHasDiscount = variant.hasDiscount;
    productGalleryOverlayMDV.setHasDiscount = variant.hasDiscount;
    productFormMDV.setNotHasDiscount = !variant.hasDiscount;
    productFormMDV.setSavingTotal = variant.savingTotal;
    productFormMDV.setCompareAtSavingTotal = variant.compareAtSavingTotal;
    productFormMDV.setDiscountPercent = variant.discountPercentage.standard;
    productGalleryOverlayMDV.setDiscountPercent = variant.discountPercentage.standard;
    productFormMDV.setDiscountPercentBase = variant.discountPercentage.base;
    productFormMDV.setHasCompareAtPrice = variant.hasCompareAtPrice;
    productFormMDV.setCompareAtPrice = variant.compareAtPrice;
    productFormMDV.setHasFinance = variant.hasFinance && variantEligibleForFinance;
    productFormMDV.setInstalmentPrice = financeInstalmentValue;
    productFormMDV.setOriginalInstalmentPrice = variant.finance.originalInstalmentPriceFormatted;
    productFormMDV.setInstalmentMonths = variant.finance.instalmentMonths;
    productFormMDV.setEcoTax = variant.ecoTax;
    if (variant.external) productFormMDV.setAtcExternalURL = variant.external;

    return data;
  }

  /**
   * Get variant data from variantSelect selected value.
   * @return {object} data required for price update sequence.
   */
  function collateData() {
    var variantId = $variantSelect.find(':selected').is(':disabled') ? $variantSelect.prop('value') : $variantSelect.val();

    return {
      variant: Simba.ProductAsync.load(variantId)
    };
  }

  /**
   * Get variant data from event
   *  {
   *     variant: Simba.Product[variantId]
   *  }
   * @return {object} data required for price update sequence.
   */
  function eventData(evt) {
    return evt.detail;
  }

  /**
   * Emit 'variant:change' event.
   * @param {object} data collateData output.
   */
  function emitVariantChange(data) {
    if (typeof window.Simba.MattressPricePopulate === 'function') {
      window.Simba.MattressPricePopulate();
    }
    Simba.Event.emit('variant:change', data);
  }
})();

/**
 * Product select.
 * Only for mattress product.
 */
(function ProductSelect() {
  var $productSelect = $('[data-product-form] [data-product-select]');
  if ($productSelect.length) {
    $productSelect.on('change', function () {
      var $this = $(this);
      var handle = $this.val();
      window.location = '/products/' + handle;
    });
  }
})();

/**
 * Product EADD.
 *
 * Show or hide the EADD message on PDPs based on selected variant.
 */
(function EADD() {
  const earliestDeliveryMessages = document.querySelectorAll('[data-earliest-message]');
  const deliveryMessages = document.querySelectorAll('[data-delivery-message]');

  document.addEventListener('variant:change', updateEADD, false);

  function updateEADD(event) {
    const variant = event.detail.variant;
    const currentMessage = getMessage(variant?.id);

    removeProps();

    if (typeof variant !== 'object') {
      return;
    }

    hideMessages(earliestDeliveryMessages, true);

    if (currentMessage !== null && currentMessage !== 'undefined') {
      currentMessage.classList.remove('hidden');

      if (currentMessage.hasAttribute('data-hide-delivery')) {
        hideMessages(deliveryMessages, true);
      }

      addProps(variant.id);
    } else {
      hideMessages(deliveryMessages, false);
    }
  }

  /**
   * Hide or show the supplied messages.
   *
   * @param {NodeList} messages
   * @param {Boolean} hide
   */
  function hideMessages(messages, hide) {
    messages.forEach((message) => {
      if (hide) {
        message.classList.add('hidden');
      } else {
        message.classList.remove('hidden');
      }
    });
  }

  /**
   * Get the EADD message for the variant.
   *
   * @param {Number} variantId
   * @return {Element}
   */
  function getMessage(variantId) {
    return document.querySelector('[data-earliest-message="' + variantId + '"]');
  }

  /**
   * Add the necessary line item properties.
   *
   * @param {Number} variantId
   */
  function addProps(variantId) {
    const prop = buildProp(variantId);
    document.querySelectorAll('[data-product-line-properties]').forEach((properties) => {
      properties.appendChild(prop);
    });
  }

  /**
   * Remove any EADD line item properties.
   */
  function removeProps() {
    document.querySelectorAll('.eddHiddenProp').forEach((prop) => prop.remove());
  }

  /**
   * Build a EADD line item property element.
   *
   * @param {Number} variantId
   * @return {HTMLInputElement}
   */
  function buildProp(variantId) {
    return Object.assign(document.createElement('input'), {
      type: 'hidden',
      name: 'properties[EADD]',
      value: variantId,
      className: 'eddHiddenProp'
    });
  }
})();

/**
 * Product form add to cart.
 */
(function ProductFormAddToCart() {
  // Variant change event listeners
  document.addEventListener('variant:change', updateAddToCart, false);
  document.addEventListener('variant:change', pushVariantChange, false);

  // True once user interacts with an option picker
  let userVariantInteraction = false;

  // All possible product option pickers on site
  const OPTION_PICKER_SELECTORS = [
    '[data-variant-select]',
    '[data-add-to-cart-variant-select]',
    '.colour-selector-group-dialog__btn',
    '.product-form__variant-select',
    '.storage-switch-option--container',
    '.atomic-radio',
    '.atomic-select',
    '.leg-switch-option--container',
    '.pack_size_button',
    '.size-selector__option'
  ].join(', ');

  // Run our watcher
  watchVariantInteraction();

  /**
   * Listens for clicks and changes on the option pickers and sets
   * `userVariantInteraction` to true the first time the shopper uses one
   */
  function watchVariantInteraction() {
    // Used to switch off both listeners in one go
    const listeners = new AbortController();
    const listenerOptions = { capture: true, signal: listeners.signal };

    // Check if the event was triggered by a person and on an option picker
    function checkIfOptionWasPicked(event) {
      const wasDoneByUser = event.isTrusted;
      const element = event.target;
      const isPageElement = element instanceof Element;
      const isOnAnOptionPicker = isPageElement && element.closest(OPTION_PICKER_SELECTORS) !== null;

      if (wasDoneByUser && isOnAnOptionPicker) {
        userVariantInteraction = true;
        listeners.abort();
      }
    }

    // Listeners
    document.addEventListener('click', checkIfOptionWasPicked, listenerOptions);
    document.addEventListener('change', checkIfOptionWasPicked, listenerOptions);
  }

  /**
   * Pushes variant change data to Google Tag Manager.
   *
   * Only pushes when the product, variant or SKU differs from the previous push,
   * so repeated 'variant:change' events for the same variant are ignored.
   *
   * @param {CustomEvent} event - The variant:change event
   * @returns {Promise<void>}
   */
  async function pushVariantChange(event) {
    const optionData = {
      productId: event.detail.variant.productId,
      variantId: event.detail.variant.id,
      sku: event.detail.variant.sku
    };

    if (
      !pushVariantChange.previousData ||
      pushVariantChange.previousData.productId !== optionData.productId ||
      pushVariantChange.previousData.variantId !== optionData.variantId ||
      pushVariantChange.previousData.sku !== optionData.sku
    ) {
      if (pushVariantChange.previousData) {
        if (pushVariantChange.previousData.productId !== optionData.productId) {
          const eventData = await Simba.gtmConstructEventData('ProductGroupSelectionChange', optionData);
          Simba.gtmPushEvent(eventData);
        }
      }

      pushVariantChange.previousData = optionData;

      optionData.hasUserInteraction = userVariantInteraction;
      const eventData = await Simba.gtmConstructEventData('ProductSelectionChange', optionData);
      Simba.gtmPushEvent(eventData);
    }
  }

  /**
   * Updates the state of Add to Cart buttons based on variant availability
   *
   * Disables/enables the add to cart buttons whenever a variant changes,
   * according to the variant's availability status.
   *
   * @param {CustomEvent} event - The variant:change event
   * @returns {void}
   */
  function updateAddToCart(event) {
    const variant = event.detail.variant;
    if (!variant) return;

    const productId = variant.productId;
    if (!productId) return;

    if (typeof variant.available === 'undefined') return;
    const disabled = !variant.available;

    const atcButtons = document.querySelectorAll(`[data-atc-submit][data-atc-product-id="${productId}"]`);
    if (!atcButtons) return;

    // Update each button's disabled state
    atcButtons.forEach((atcButton) => {
      atcButton.disabled = disabled;
    });
  }
})();
